import type { StudentAchievementRoutes } from 'ulanano-cms-api/routes/student-achievements'
import { createGranularTreaty } from '../api-factory'

export const studentAchievementsApi = createGranularTreaty<StudentAchievementRoutes>({ withCookies: true })
